module.exports = Vuex;


//////////////////
// WEBPACK FOOTER
// external "Vuex"
// module id = 3
// module chunks = 30